import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'inside-out/components/shared/link';
import { SocialIcons } from 'inside-out/components/shared/socialIcons';

import logo from 'inside-out/images/logo.svg';
import hamburgerMenuIcon from 'inside-out/images/hamburger-icon.svg';
import closeIcon from 'inside-out/images/close-icon.svg';
import {
	wrapperStyle,
	innerWrapperStyleHidden,
	innerWrapperStyleShown,
	sectionsStyle,
	sectionTitleStyle,
	columnsStyle,
	logoStyle,
	menuIconStyle,
	topSectionMobile,
	termsAndCopyrightWrapper,
	termsAndCopyright,
	mobileSocialIconsStyle,
} from './styles';

class FooterComponent extends React.PureComponent {
	state = {
		show: true,
	};

	handleToggleClick = () => {
		this.setState({ show: !this.state.show });
	};

	renderFooterBody = () => {
		const sections = this.props.sections;
		return (
			<div className={this.state.show ? innerWrapperStyleShown : innerWrapperStyleHidden}>
				<div className={mobileSocialIconsStyle}>
					<SocialIcons mode="share" width={18} inline center />
				</div>
				<div className={columnsStyle}>
					<div className={logoStyle}>
						<img src={logo} alt="Inside Out : Institute for Eating Disorders" />
						<SocialIcons mode="share" width={18} inline center />
					</div>
					<div className={sectionsStyle}>
						{sections &&
							sections.map(section => (
								<div key={Math.random() * 99999}>
									<div className={sectionTitleStyle}>{section.title}</div>
									{section.component}
								</div>
							))}
					</div>
				</div>
				<div className={termsAndCopyrightWrapper}>
					<div className={termsAndCopyright}>
						<nav>
							<Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
							<Link to="/privacy-policy">Privacy Policy</Link>
						</nav>
						<p>&copy; {new Date().getFullYear()} InsideOut</p>
					</div>
				</div>
			</div>
		);
	};

	render() {
		return (
			<footer className={wrapperStyle}>
				<div className={topSectionMobile}>
					<div className={menuIconStyle}>
						<img
							src={this.state.show ? closeIcon : hamburgerMenuIcon}
							alt="TODO"
							onClick={this.handleToggleClick}
						/>
					</div>
				</div>
				{this.renderFooterBody()}
			</footer>
		);
	}
}

FooterComponent.propTypes = {
	sections: PropTypes.array,
};

export const Footer = FooterComponent;



// WEBPACK FOOTER //
// ./src/components/shared/footer/component.js